import { useFrame } from "@react-three/fiber";
import { useRef } from "react";

function HorizontalPlane({
  targetRef,
  zLength = 50,
  color = "red",
  xLength = 50,
}) {
  const planeRef = useRef();

  useFrame(() => {
    if (targetRef.current && planeRef.current) {
      const pos = targetRef.current.position;
      planeRef.current.position.set(pos.x, pos.y, pos.z);
    }
  });

  return (
    <mesh ref={planeRef}>
      <boxGeometry args={[xLength, 0.1, zLength]} />
      <meshBasicMaterial color={color} transparent opacity={0.1} />
    </mesh>
  );
}

export default HorizontalPlane;
